import { DataTable } from "@galigeo-store/shared-models";

export class Geocode {
    public search(value: string): Promise<DataTable> {
        return new Promise<any>((resolve, reject) => {
            resolve(new DataTable({}));
        });
    }
}